import { useCallback } from 'react';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppState } from 'customHooks/useAppState';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { LONG_DATE_FORMAT, formatDate, isoDateFromServer } from 'helpers/dates';
import { DateTime } from 'luxon';

const NextBillDueCallout = () => {
    const { accountId, validGivebutterPlusPlan } = useCurrentAccount();
    const { apiUrl } = useAppState();
    const NextBillDueDateMessage = useCallback(() => {
        const subscriptionEnd = validGivebutterPlusPlan?.ends_at;

        if (!subscriptionEnd) {
            return null;
        }

        const dateFromServer = isoDateFromServer(subscriptionEnd);
        if (dateFromServer > DateTime.now()) {
            return (
                <div className="flex flex-wrap items-center justify-between gap-4">
                    <p>
                        You have access to Givebutter Plus until your subscription ends on{' '}
                        <span className="font-semibold">
                            {formatDate(dateFromServer, LONG_DATE_FORMAT)}
                        </span>
                    </p>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        className="text-nowrap"
                        href={`${apiUrl}/dashboard/accounts/${accountId}/billing`}
                    >
                        Renew
                    </a>
                </div>
            );
        }
    }, [validGivebutterPlusPlan?.ends_at, accountId, apiUrl]);

    return (
        NextBillDueDateMessage() && (
            <div className="flex items-center gap-3 rounded-lg bg-gray-100 px-4 py-3">
                <FontAwesomeIcon icon={faCalendar} className="text-gray-500" />
                <div className="w-full text-sm text-gray-700">
                    <NextBillDueDateMessage />
                </div>
            </div>
        )
    );
};

export { NextBillDueCallout };
